import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../auth/auth.service';
import { RedirectConstants } from '../constants/redirect.constants';
import { GeneralRoutePaths } from '../enums/route-types.enum';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  private router = inject(Router);
  private authService = inject(AuthService);

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const user = this.authService.getUser();
    const url = state.url[0] === '/' ? state.url.slice(1) : state.url;

    if (user) {
      return true;
    }

    if (url.trim().length > 1 && url !== GeneralRoutePaths.LOGOUT) {
      sessionStorage.setItem(RedirectConstants.SESSION_STORAGE_KEY, JSON.stringify({ url: state.url }));
    }

    this.router.navigate([GeneralRoutePaths.SIGN_IN]);

    return false;
  }
}
